import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';

interface versionRequest {
  app_version: string;
}

interface versionResponse {}

interface coreNewInfo {
  app_version: string;
  app_download_url: string;
  app_status: number;
  app_update_notice: string;
  update_switch: number;
  prompt_count: number;
}

interface coreResponse {
  new_info: coreNewInfo;
}

// install package version
export function apiGetVersionInfo(data: versionRequest) {
  return request<versionResponse>({
    method: 'POST',
    url: httpApi.home.versionInfo,
    data
  });
}

// core package version
export function apiGetCoreVersion(data: versionRequest) {
  return request<coreResponse>({
    method: 'POST',
    url: httpApi.home.coreVersion,
    data
  });
}
